module.exports = __webpack_public_path__ + "static/media/g6p.4b334603.jpg";